import React, { useReducer, useEffect, useState } from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  Editing,
  Popup,
  Form,
  Item,
  Paging,
  Pager,
  Toolbar,
} from "devextreme-react/data-grid";
import Calendar from "devextreme-react/calendar";
import Button from "devextreme-react/button";
import { Popover } from "devextreme-react/popover";
import * as actions from "../../../actions/dashboard";
import dashboardReducer from "../../../reducers/dashboard";
import { GRID_CONFIG } from "./config";
import { GetAllWeeks, GetWeek } from "./utils";
import moment from "moment";
import SelectBox from "devextreme-react/select-box";
import RadioGroup from "devextreme-react/radio-group";
import { Toast } from "devextreme-react/toast";
import DateBox from "devextreme-react/date-box";
const initialState = { gembaData: [], gembaTypes: null };

export default ({ siteId, tierId, isEditable, widgetInfo }) => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);
  const [showCal, setShowCal] = useState(false);
  let { gembaData, gembaTypes } = state;
  const [curMonthVal, setCurMonthVal] = useState(new Date());
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [showExportForm, setShowExportForm] = useState(false);
  const [exportFilter, setExportFilter] = useState(0);
  const [weekList, setWeekList] = useState([]);
  const [startWeek, setStartWeek] = useState();
  const [endWeek, setEndWeek] = useState();
  //const [gData, setGData] = useState([])
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });
  const WID_TYPE =
    widgetInfo && widgetInfo.filter && widgetInfo.filter == "attendance"
      ? "Attendance"
      : "Gemba";
  const [durationType, setDurationType] = useState(
    WID_TYPE == "Attendance" ? "day" : "week"
  );
  useEffect(() => {
    let y = sDate.getFullYear(),
      m = sDate.getMonth() + 1;
    actions.fetchGembaData(
      dispatch,
      `widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&type=${WID_TYPE}&DurationType=${durationType}&y=${y}&m=${m}`
    );
    actions.fetchGembaTypes(dispatch, siteId);
    let weekNumber = GetAllWeeks();
    setWeekList(weekNumber);
  }, []);

  let gembaTypeList = ["Y", "N"];
  if (WID_TYPE == "Gemba" && gembaTypes && gembaTypes.length > 0) {
    let gemTypes = gembaTypes.map((d) => d.gembaType);
    gembaTypeList = ["N", ...gemTypes];
  }

  const onRowUpdating = (e) => {
    let values = Object.values(e.newData);
    let keys = Object.keys(e.newData);
    let weekVal = keys[0].split("_");
    let y = curMonthVal.getFullYear(),
    m = curMonthVal.getMonth() + 1;
    let data = {
      SiteID: e.oldData.SiteID,
      TierID: e.oldData.TierID,
      EmployeeID: e.oldData.EmployeeID,
      EmployeeName: e.oldData.EmployeeName,
      weekNo:WID_TYPE == "Attendance"? keys[0] : weekVal[1],
      IsAttended: values[0],
      type: WID_TYPE,
      DurationType: durationType,
      widgetId: widgetInfo.widgetId,
      year:y,
      month:m
    };
    
    actions.updateGemba(
      dispatch,
      data,
      `widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&y=${y}&m=${m}&type=${WID_TYPE}&DurationType=${durationType}`
    );
  };

  const onExporting = (e) => {
    let eFileName = "Honeywell " + WID_TYPE;
    if (showExportForm) {
      if (exportFilter != 2) {
        if (startWeek && endWeek) {
          if (startWeek > endWeek) {
            setToastConfig({
              isVisible: true,
              type: "warning",
              message: "Start week should be smaller than end week.",
            });
            return;
          }
          actions.exportData(
            `digitaltier/exportGembaDetails?widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&startWeek=${startWeek}&endWeek=${endWeek}&type=${WID_TYPE}&DurationType=${durationType}`,
            eFileName
          );
          setStartWeek(null);
          setEndWeek(null);
          setShowExportForm(false);
          setExportFilter(0);
        } else
          actions.exportData(
            `digitaltier/exportGembaDetails?widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&type=${WID_TYPE}&DurationType=${durationType}`,
            eFileName
          );
      } else {
        if (moment(sDate) > moment(eDate)) {
          setToastConfig({
            isVisible: true,
            type: "warning",
            message: "Start date should be less than End date.",
          });
          return;
        }
        let startDate = moment(sDate).format("DD/MM/YYYY"),
          endDate = moment(eDate).format("DD/MM/YYYY");
        actions.exportData(
          `digitaltier/exportGembaDetails?widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&type=${WID_TYPE}&DurationType=${durationType}&startDate=${startDate}&endDate=${endDate}`,
          eFileName
        );
        setShowExportForm(false);
        setExportFilter(0);
      }
    }

    e.cancel = true;
  };

  const cellRender = (data) => {
    let tpl = "";

    if (data.value === "N")
      tpl = (
        <div className="cell-red">
          <i className="fas fa-times" style={{ fontSize: "1.5em" }}></i>
        </div>
      );
    if (data.value !== "N" && data.value != "")
      tpl = (
        <div className="cell-green">
          <i className="fas fa-check" style={{ fontSize: "1.5em" }}></i>
        </div>
      );

    return tpl;
  };

  const getColDef = () => {
    let newDate = new Date();
    if (gembaData && gembaData[0]) {
      let items = Object.keys(gembaData[0]);
      let colDef = [];

      for (let i = 0; i < items.length; i++) {
        if (i < 3)
          colDef.push(<Column key={i} dataField={items[i]} visible={false} />);
        else if (i == 3)
          colDef.push(
            <Column key={i} dataField={items[i]} caption="Name" />
          );
        else {
          colDef.push(
            <Column
              key={i}
              dataField={items[i]}
              cssClass={
                items[i].toLowerCase() === `week_${GetWeek(newDate) - 1}`
                  ? "cell-highlight"
                  : ""
              }
              cellRender={cellRender}
            >
              <Lookup dataSource={gembaTypeList} />
            </Column>
          );
        }
      }
      return colDef;
    }
    return [];
  };

  return (
    <>
      {showExportForm && (
        <div className="m-w-572" style={{ width: "100%", maxWidth: "100%" }}>
          {(WID_TYPE == "Gemba" || durationType == "week") && (
            <div>
              <RadioGroup
                items={[
                  { id: 0, text: "All" },
                  { id: 1, text: "Week range" },
                ]}
                value={exportFilter}
                valueExpr="id"
                displayExpr="text"
                onValueChanged={(e) => setExportFilter(e.value)}
                layout="horizontal"
              />
            </div>
          )}
          {WID_TYPE == "Attendance" && durationType != "week" && (
            <div>
              <RadioGroup
                items={[
                  { id: 0, text: "All" },
                  { id: 2, text: "Date range" },
                ]}
                value={exportFilter}
                valueExpr="id"
                displayExpr="text"
                onValueChanged={(e) => setExportFilter(e.value)}
                layout="horizontal"
              />
            </div>
          )}

          <div
            className="d-flex"
            style={{
              justifyContent: "space-between",
              alignItems: "flex-end",
              flexWrap: "wrap",
              width: "100%",
              padding: "10px",
            }}
          >
            {exportFilter == 1 && (
              <div className="alert-container">
                <span>
                  Start week:{" "}
                  <SelectBox
                    onValueChanged={(e) => {
                      // find day in year

                      let weeknum = e.value.split(" ")[1];

                      setStartWeek(weeknum);
                    }}
                    items={weekList}
                  />
                </span>
                <span style={{ marginLeft: "10px" }}>
                  End week:{" "}
                  <SelectBox
                    onValueChanged={(e) => {
                      // find day in year
                      let weeknum = e.value.split(" ")[1];
                      setEndWeek(weeknum);
                    }}
                    items={weekList}
                  />
                </span>
              </div>
            )}
            {exportFilter == 2 && (
              <div className="alert-container">
                <span>
                  Start date:{" "}
                  <DateBox
                    value={sDate}
                    onValueChanged={(e) => setSDate(e.value)}
                    useMaskBehavior={true}
                    type="date"
                  />
                </span>
                <span style={{ marginLeft: "10px" }}>
                  End date:{" "}
                  <DateBox
                    value={eDate}
                    onValueChanged={(e) => setEDate(e.value)}
                    type="date"
                    useMaskBehavior={true}
                  />
                </span>
              </div>
            )}
            <div className="cbtn d-flex justify-space-between align-items-center">
              <button
                onClick={(e) => onExporting(e)}
                className="btn secondary-btn"
              >
                Export
              </button>
              <button
                onClick={() => {
                  setShowExportForm(!showExportForm);
                }}
                className="btn primary-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="gem-month-info">
        {" "}
        Month: <b>{moment(curMonthVal).format("MMM YYYY")}</b>
      </div>

      <div className="gem-fltr-adj ">
        <div className="dx-field-value-static d-flex">
          {WID_TYPE == "Attendance" && (
            <SelectBox
            visible = {false}
              style={{ height: "38px" }}
              items={[
                { id: "day", name: "Daily" },
                { id: "week", name: "Weekly" },
                { id: "month", name: "Monthly" },
              ]}
              value={durationType}
              displayExpr="name"
              valueExpr="id"
              onValueChanged={(e) => {
                setExportFilter(0);
                let y = curMonthVal.getFullYear(),
                  m = curMonthVal.getMonth() + 1;
                actions.fetchGembaData(
                  dispatch,
                  `widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&y=${y}&m=${m}&type=${WID_TYPE}&DurationType=${e.value}`
                );
                setDurationType(e.value);
              }}
            />
          )}
          <button
            style={{
              padding: "10px 11px",
              cursor: "pointer",
              marginLeft: "5px",
            }}
            className="dx-button-mode-contained"
            id="link4"
            onClick={() => setShowCal(true)}
          >
            {" "}
            <i className="fas fa-calendar-alt"></i>
          </button>
          <div
            class="dx-item dx-toolbar-item dx-toolbar-button dx-toolbar-item-auto-hide"
            onClick={(e) => {
              setShowExportForm(true);
            }}
          >
            <div class="dx-item-content dx-toolbar-item-content">
              <div
                class="dx-datagrid-toolbar-button dx-datagrid-export-button dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-icon"
                aria-label="export-excel-button"
                title="Export all data"
                tabindex="0"
                role="button"
              >
                <div class="dx-button-content">
                  <i className="dx-icon dx-icon-xlsxfile"></i>
                </div>
              </div>
            </div>
          </div>

          <Popover
            target="#link4"
            position="top"
            width={334}
            visible={showCal}
            onHiding={() => setShowCal(false)}
          >
            <div style={{ padding: "5px" }}>
              <Calendar
                id="calendar-container"
                value={curMonthVal}
                onValueChanged={(e) => {
                  let y = e.value.getFullYear(),
                    m = e.value.getMonth() + 1;
                  actions.fetchGembaData(
                    dispatch,
                    `widgetId=${widgetInfo.widgetId}&siteId=${siteId}&tierId=${tierId}&y=${y}&m=${m}&type=${WID_TYPE}&DurationType=${durationType}`
                  );
                  setCurMonthVal(e.value);
                  setShowCal(false);
                }}
                max={new Date()}
                maxZoomLevel="year"
              />
            </div>
          </Popover>
        </div>
      </div>
      <DataGrid
        dataSource={gembaData}
        allowColumnReordering={true}
        showBorders={true}
        {...GRID_CONFIG}
        onRowUpdating={onRowUpdating}
        onExporting={onExporting}
        rowAlternationEnabled={false}
        repaintChangesOnly={true}
      >
        <Paging defaultPageSize={4} />
        <Pager
          visible={true}
          allowedPageSizes={[4, 8, 12]}
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true}
        />

        {isEditable && <Editing mode="cell" allowUpdating={true} />}
        {getColDef()}
      </DataGrid>
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={() =>
          setToastConfig({
            ...toastConfig,
            isVisible: false,
          })
        }
        displayTime={2000}
      />
    </>
  );
};
